<template>
  <div class="changeCategory">
    <!-- <div v-if="pubishState" class="choose_category_option">
      <div v-if="$props.showCategory" class="category_item">
        <h2>अपना श्रेणी चुने</h2>
        <ul>
          <li
            :class="$store.state.selected == key ? 'active' : ''"
            v-for="(category, key) in $t('categoryNew')"
            :key="key"
            @click="handleCategorySelect(mobile_no, key, room_id)"
          >
            <div class="catgIcon">
              <img :src="require(`@/assets/images/cat${key}.png`)" />
            </div>
            <div class="catgrightcol">
              <h3>{{ category.name }}</h3>
              <p>{{ category.paragraph }}</p>
            </div>
          </li>
        </ul>
      </div>
    </div> -->
    <div id="shoppingModal" class="wallet modal">
      <!-- - Modal content -->
      <div class="modal-content liveItem_part">
        <button
          id="myBtn"
          type="button"
          class="close1"
          @click.prevent="closeModal()"
        >
          <span><img src="../assets/images/bag.png"/></span>
        </button>
        <!-- @true="noLiveProduct" -->
        <BroadCasterProductList
          :channel="room_id"
          :xAuthId="xAuthId"
          @livedProduct="livedProducthandle"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BroadCasterProductList from './BroadCasterProductList'
export default {
  name: 'ChangeCategory',
  components: { BroadCasterProductList },
  props: [
    'room_id',
    'xAuthId',
    'pubishState',
    'app_id',
    'mobile_no',
    'showCategory'
  ],
  data() {
    return {
      categoryNew: [],
      noLive: false,
      productlist: [],
      showCategoryProps: this.$props.showCategory,
      showCategoryactive: 'money91'
    }
  },
  methods: {
    handleOpen() {
      this.showCategoryProps = true
    },
    closeModal() {
      $('#shoppingModal').modal('hide')
    },
    handleCategorySelect(mobile_no, category, room_id) {
      console.log(category)
      this.previousCategoryViewer = this.selectedCategory
      this.$store.commit('updateSelected', {
        selected: category
      })
      this.$socket.emit('change_category', {
        mobile_no: mobile_no,
        category: category,
        room_id: room_id
      })
      //   this.selectedCategory = category
      //   this.activeGolive = false
      this.showCategoryProps = false
      this.showCategoryactive = category
      this.$emit('handleCategoryReopen', this.showCategoryProps)
    },
    livedProducthandle() {
      console.log('---=livedProducthandle==')
      this.closeModal()
    }
  },
  mounted() {
    $('#shoppingModal').modal('show')
  },
  sockets: {
    // broadcaster_ordered_history: function(data) {
    //   console.log('==-data-==broadcaster_ordered_history--chnage-', data)
    //   // if (data.data.length > 0) {
    //   //   this.noLive = false
    //   //   this.$store.commit('broadCastProductList', data.data)
    //   //   this.productlist = data.data
    //   //   this.$store.commit('noLive', this.noLive)
    //   // } else {
    //   //   this.noLive = true
    //   //   this.$store.commit('noLive', this.noLive)
    //   // }
    //   // if (this.productlist.length > 0) this.shoppingActive = true
    // }
  }
}
</script>
